import Actions from './Actions.connect';

export default Actions;
